import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../dashboardActionTypes";
import { Pie } from "react-chartjs-2";
import Legend from "../../common/chart/Legend";
import WidgetErrorMessage from "./WidgetErrorMessage";
import WidgetReloader from "./WidgetReloader";
import WidgetOverlayLinkToTa from "./WidgetOverlayLinkToTa";
import severityLevel from "../../common/severityConfig";
import {
  getSecurityAlertsLastMonth,
  getSecurityAlertsLastMonthIsLoading
} from "../dashboardSelector";
import * as dashboardActions from "../dashboardActions";
import Spinner from "../../common/progress/Spinner";
import Widget from "./Widget";
import { translate } from "react-i18next";

class SecurityAlertsLastMonthWidget extends Component {
  constructor(props) {
    super(props);
    this.onReload = this.onReload.bind(this);
  }

    componentDidMount() {
        if (this.props.customerInformation.siem != "wazuh") {
            this.props.actions.loadSecurityAlertsForLastMonth();
        }
  }

    onReload() {

        if (this.props.customerInformation.siem != "wazuh") {
            this.props.actions.loadSecurityAlertsForLastMonth();
        }
  }

  render() {
      const {
      customerInformation,
      errors,
      isLoading,
      actions,
      securityAlertsLastMonth,
      t
    } = this.props;

    const options = {
      legend: {
        display: false
      }
    };
    const labels = securityAlertsLastMonth.labels;
    const pieLabels = [
      t("lowSeverity"),
      t("mediumSeverity"),
      t("highSeverity")
    ];
    const lastMonthError = errors.filter(
      err => err.key === types.LOAD_SECIURITY_ALERTS_LAST_MONTH_FAILED
    );

    const hasErrors = lastMonthError.length > 0;
      const errorMessage = hasErrors ? lastMonthError[0].message : "";

      const pieMockData = {
          labels: [t("lowSeverity"), t("mediumSeverity"), t("highSeverity")],
          datasets: [
              {
                  data: [20, 15, 5],
                  backgroundColor: ["#2cbafc", "#fd9e29", "#d419a8" ],
              },
          ],
      };

      const severityMockLabels = {
          lowSeverity: { count: 20, severity: 0 },
          mediumSeverity: { count: 15, severity: 1 },
          highSeverity: { count: 5, severity: 2 }
      };

      if (customerInformation.siem === "wazuh") {
          return (
              <Widget
                  header={t("securityAlertsLastMonthWidgetTitle")}
                  onReload={this.onReload}
              >
                  <WidgetOverlayLinkToTa buttonText={t("logInToTa")} taUrl={customerInformation.technicalAnalysisUrl} />

               

                  <div className="pie-wrapper">
                      <Pie
                          width={100}
                          height={100}
                          data={pieMockData}
                          options={options}
                      />
                  </div>
                  <Legend labels={severityMockLabels} />
              </Widget>
          );
      }

    if (isLoading) {
      return (
        <Widget
          header={t("securityAlertsLastMonthWidgetTitle")}
          onReload={this.onReload}
          isLoading={isLoading}
        >
          <div className="pie-wrapper align-center">
            <div className="text-center">
              <Spinner />
            </div>
          </div>
        </Widget>
      );
    }
    
    if (hasErrors) {
      return (
        <Widget
          header={t("securityAlertsLastMonthWidgetTitle")}
          onReload={this.onReload}
        >
          <div className="overlay overlay-default">
            <WidgetErrorMessage onClick={this.onReload} />
          </div>
        </Widget>
      );
    }

   

    return (
      <Widget
        header={t("securityAlertsLastMonthWidgetTitle")}
        onReload={this.onReload}
      >
        <div className="pie-wrapper">
          <Pie
            width={100}
            height={100}
            data={{
              datasets: securityAlertsLastMonth.datasets,
              labels: pieLabels
            }}
            options={options}
          />
        </div>
        <Legend labels={securityAlertsLastMonth.labels} />
      </Widget>
    );
  }
}

SecurityAlertsLastMonthWidget.propTypes = {
  securityAlertsLastMonth: PropTypes.object.isRequired,
  customerInformation: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired
};

const mapStateToProps = state => {
  return {
    errors: state.errors,
    isLoading: getSecurityAlertsLastMonthIsLoading(state),
    customerInformation: state.customerInformation,
    securityAlertsLastMonth: getSecurityAlertsLastMonth(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(dashboardActions, dispatch)
  };
};

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SecurityAlertsLastMonthWidget)
);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/SecurityAlertsLastMonthWidget.js